import logo from "../images/logo.png";
import { TextField, Button } from "@mui/material";
import "../styles/login.scss";
import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import InputAdornment from "@mui/material/InputAdornment";
import AccountCircle from "@mui/icons-material/AccountCircle";
import LockIcon from "@mui/icons-material/Lock";
import { Alert } from "@mui/material";
import PasswordReset from "./PasswordReset";
import { Modal } from "@mui/material";

export default function Login() {
  const url = process.env.REACT_APP_URL;
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  //Modals
  const [passwordReset, setPasswordReset] = useState(false);
  //Alerts
  const [alert, setAlert] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [disable, setDisable] = useState(false);

  const handleAlert = (message, severity, duration = 4000) => {
    setMessage(message);
    setSeverity(severity);
    setAlert(true);
    setTimeout(() => {
      setAlert(false);
      setMessage("");
      setSeverity("");
      setDisable(false);
    }, duration);
  };

  const handleValidation = () => {
    setDisable(true);
    if (username === "") {
      handleAlert("Please enter a username", "warning");
    } else if (password === "") {
      handleAlert("Please enter your password", "warning");
    } else {
      handlelogin();
    }
  };

  const handlelogin = async () => {
    let reqBody = {
      username: username,
      password: password,
    };
    await axios
      .post(`${url}/login`, reqBody)
      .then((res) => {
        localStorage.setItem("userId", res.data.userId);
        localStorage.setItem("username", res.data.username);
        if (res.data.firstLogin) {
          navigate("/create-password");
        } else {
          localStorage.setItem("access", res.data.access);
          navigate("/home");
        }
      })
      .catch((err) => {
        console.log(err);

        handleAlert(`${err.response.data.message}`, "error");
      });
  };

  const enter = (e) => {
    if (e.keyCode === 13) {
      handleValidation();
    }
  };

  return (
    <main className="login__page">
      <section className="login__form_wrapper">
        <aside className="login__form">
          <img src={logo} alt="PMW Wings" />
          <h1>PMW Inventory System</h1>
        </aside>
        <article className="login__form">
          <TextField
            label="Username"
            variant="standard"
            onChange={(e) => setUsername(e.target.value)}
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <AccountCircle />
                  </InputAdornment>
                ),
              },
            }}
          />
          <TextField
            label="Password"
            variant="standard"
            type="password"
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={(e) => enter(e)}
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <LockIcon />
                  </InputAdornment>
                ),
              },
            }}
            sx={{ marginTop: "2%" }}
          />
          <section className="alert-section">
            {alert ? <Alert severity={severity}>{message}</Alert> : null}
          </section>
          <p className="password-reset">
            Forgotten Password? Click{" "}
            <span
              onClick={() => {
                setPasswordReset(true);
              }}
            >
              here
            </span>{" "}
            to reset.
          </p>
          <Button
            variant="contained"
            className="loginBtn"
            onClick={handleValidation}
            disabled={disable}
          >
            Login
          </Button>
        </article>
      </section>
      {/* MODALS */}
      <Modal open={passwordReset}>
        <PasswordReset handleClose={setPasswordReset} />
      </Modal>
    </main>
  );
}
